const preventCopy = function (evt) {
    evt.clipboardData.setData(
        "text/plain",
        window ? window.location.href : 'Not allowed to copy from this website!'
    );
    evt.preventDefault();
}

const handleCopyLayer = function (to) {
    const preventRightClick = function (evt) { evt.preventDefault(); };
    document.removeEventListener("contextmenu", preventRightClick, false);
    document.removeEventListener("copy", preventCopy, false);
    if (!to.meta.allowCopy && process.env.VUE_APP_ENV != 'hml') {
        document.addEventListener("contextmenu", preventRightClick, false);
        document.addEventListener("copy", preventCopy, false);
    }
}

export {
    preventCopy,
    handleCopyLayer
}